import { render, staticRenderFns } from "./BrickTimerSettings.vue?vue&type=template&id=0b560dea&"
import script from "./BrickTimerSettings.vue?vue&type=script&lang=js&"
export * from "./BrickTimerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b560dea')) {
      api.createRecord('0b560dea', component.options)
    } else {
      api.reload('0b560dea', component.options)
    }
    module.hot.accept("./BrickTimerSettings.vue?vue&type=template&id=0b560dea&", function () {
      api.rerender('0b560dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickTimerSettings.vue"
export default component.exports